import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'CREATE_ORDER_SHIPMENT_CHANGED';
const context = {
    pendingStagingShipmentId: null,
    offer: null,
};
const CreateOrderShipmentStore = assign({}, EventEmitter.prototype, {
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    onCreateOrderShipmentRequest(offer) {
        if (offer) {
            const { staging_id: pendingStagingShipmentId } = offer;
            context.pendingStagingShipmentId = pendingStagingShipmentId;
        }
    },
    onCreateOrderShipmentSuccess(offer) {
        context.offer = offer;
        context.completed = true;
        context.success = true;
        this.emitChange();
    },
    onCreateOrderShipmentFail(error) {
        context.offer = null;
        context.error = error;
        context.completed = true;
        context.success = false;
        this.emitChange();
    },
    getContext() {
        return context;
    },
});
CreateOrderShipmentStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.CREATE_ORDER_SHIPMENT_REQUEST:
            CreateOrderShipmentStore.onCreateOrderShipmentRequest(action.offer);
            break;
        case ActionTypes.CREATE_ORDER_SHIPMENT_SUCCESS:
            CreateOrderShipmentStore.onCreateOrderShipmentRequest(action.offer);
            break;
        case ActionTypes.CREATE_ORDER_SHIPMENT_FAIL:
            CreateOrderShipmentStore.onCreateOrderShipmentFail(action.error);
            break;
        default:
            break;
    }
});
export default CreateOrderShipmentStore;
